import helper from "@/form_builder/components/form/ui/helper.js";

export default {
  vue_tag: "input",
  tag: "el-time-picker",
  name: "Tipo Tiempo",
  __openRules: false,
  tagIcon: "time",
  ctrlBtn: true,
  defaultvalue: null,
  formItem: {
    showLabel: helper.input_boolean("Mostrar etiqueta", true),
    // labelWidth: helper.input_number("Ancho etiqueta", 100),
    label: helper.input_text("Etiqueta", "Campo"),
  },
  attrs: {
    fieldName: helper.input_text("Nombre de campo", "nombre de campo"),
    // readonly: helper.input_boolean("完全只读", false),
    // disabled: helper.input_boolean("禁用", false),
    // editable: helper.input_boolean("文本框可输入", true),
    // clearable: helper.input_boolean("是否显示清除按钮", true),
    // "is-range": helper.input_boolean("是否为时间范围选择", false),
    // "arrow-control": helper.input_boolean("是否使用箭头进行时间选择", false),
  },
  slots: {},
  props: {},
  childrens: [],
};
